import { render } from "./books.vue?vue&type=template&id=76e2682a&scoped=true"
import script from "./books.js?vue&type=script&lang=js&external"
export * from "./books.js?vue&type=script&lang=js&external"

import "./books.css?vue&type=style&index=0&id=76e2682a&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76e2682a"]])

export default __exports__